import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"

import ApiServer from "../ApiServer.js";
import FizConfig from "../FizConfig.js";
import {EventStore} from "../server/EventStore.js";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import {TaskListCache,MetaTaskCache} from "../server/objects/TaskBeans.ts"

import Icons from "../svg/Icons.ts";

import TPL_SLOTCONTENT from "../mealplanner/slotcontent.mustache"
import TPL_CHOOSEFIRSTDAY from "../mealplanner/modal_firstday.mustache"
import TPL_PLANNING from "../mealplanner/planning.mustache";

import {apiCustommplist,dishSyncCache,getWeekRange, recipeSyncCache,MealplannerSettingsCache, updateMealplannerSettings} from "./mealplannerApi.ts"
import * as mealplannerModal from "./mealplannerModal.ts"
import { registerDragStart } from "../lib/FileUtils.ts";
import $ from "../$.js";
import { localGet, localSet } from "../lib/Storage.ts";
import { initPaneRight } from "../util/PaneRight.ts";
import "../util/taskutil.js"
import * as recipeModal from "./recipeModal.ts";



var 
  range,daysByKey,selectedCalendarIds,defaultList;

function mealplannerrightpane(pane){
  if(pane===undefined){
    pane = localGet('mealplanner.rightpane')|| 'recipe'
  }
  localSet('mealplanner.rightpane',pane)
  document.querySelectorAll(".pane-selector>*").forEach(node=>{
    var addClass = node.getAttribute('data-fw-onclick')==='mealplannerrightpane|'+pane
    if(addClass){
      node.classList.add('selected')
    }else{
      node.classList.remove('selected')
    }
  })
  document.getElementById('task-list').style.display = pane==='task'?'block':'none';
  document.getElementById('recipe-list').style.display = pane==='recipe'?'block':'none';
}

actionMenu.register({
  async mppickdate(){
    var settingsPerFamily = FwDatas.getSettingsPerFamily() ;
    return {'pickdate':{
      date:range.start,
      firstDayOfWeek:settingsPerFamily.mealplannerFirstDayOfWeek,
      onpickdate:(date)=>{
        range = getWeekRange(date)
        displayWeek()
      }
    }}
  },
  async mpsettingsmenu(){
    var 
      menu = [],
      settings = await MealplannerSettingsCache.need(),
      settingsPerFamily = FwDatas.getSettingsPerFamily() ;
    
    if(settingsPerFamily.mealplannerFirstDayOfWeek!==7 && settingsPerFamily.mealplannerFirstDayOfWeek!==6){
      if(settings.showWeekEnd){
        menu.push({onclick:'mpsettingsWE|hide',svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEhide'})
      }else{
        menu.push({onclick:'mpsettingsWE|show',svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEshow'})
      }
    }else{
      if(settings.showWeekEnd){
        menu.push({onclick:'mpsettingsshowWeekEnddisabled',opacity:0.5,svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEhide'})
      }else{
        menu.push({onclick:'mpsettingsshowWeekEnddisabled',opacity:0.5,svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEshow'})
      }
    }
    
    menu.push(
      {onclick:'mpsettings',svg:Icons.clock.ic_access_time,i18nkey:'mp.manage'},
      {onclick:'mpsettingsfirstdayofweek',svg:Icons.ic_time_start,i18nkey:'calendars.settingsweekbegin'},
      {html:'<hr style="margin: 8px 0px;"/>'},
      {onclick:'mpaddtolistopen',svg:Icons.ic_add_shopping_cart,i18nkey:'mp.exporttolist'},
      {onclick:'mpcopyweek',svg:Icons.ic_duplicate,i18nkey:'mp.copyweek'},
      settings.canClear?{onclick:'mpclear',color:'var(--red)',svg:Icons.ic_delete,i18nkey:'mp.clear'}:{html:''},
      {html:'<hr style="margin: 8px 0px;"/>'},
      {onclick:'mpshare',svg:Icons.ic_export,i18nkey:'mp.share'},
      {onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'}
    )
    return {'menu':menu}
  },
  async mealplannerlist(){
    return {'menu':(await TaskListCache.need()).map(tasklist=>{
      var svgend = defaultList.metaId===tasklist.metaId?Icons.ic_checkmark:undefined
      return {onclick:'mppicklist|'+tasklist.metaId,svg:tasklist.iconsimple,title:tasklist.name,svgend}
    })}
  },
  mprecipemenu(){
    const 
      metaId = this.metaId(),
      recipe = FwDatas.get(metaId),
      menu = [];
    if(recipe.isMealSuggestion){
      menu.push({svg:Icons.ic_eye_off,i18nkey:"mp.actions.suggestionremove",onclick:'mpsuggestion|false'})
    }else{
      menu.push({svg:Icons.ic_eye,i18nkey:"mp.actions.suggestionputback",onclick:'mpsuggestion|true'})
    }
    menu.push({svg:Icons.ic_add_shopping_cart,i18nkey:"mp.addtolist",onclick:'mpadditemtolist'})
        
    menu.push({svg:Icons.ic_edit,i18nkey:"actions.edit",onclick:'mprecipeedit'})
    return {menu}
  }
})


Html.register({
  mealplannerrightpane,
  mpsuggestion(isMealSuggestion){
    const 
      metaId = this.metaId(),
      recipe = FwDatas.get(metaId);
      recipe.isMealSuggestion = isMealSuggestion==='true';
    ApiServer.mprecipeput(recipe).then(recipe=>{
      modal.toastDone(recipe.isMealSuggestion?"mp.actions.suggestionputbackdone":"mp.actions.suggestionremovedone")
    });
    amplify.publish("recipeNeedRefresh");
  },
  
  async mpsettingsfirstdayofweek(){
    const settings = await MealplannerSettingsCache.need()
    var 
      weekdays = DateUtils.getWeekDays();
      
    if(!settings.showWeekEnd){
      weekdays = weekdays.filter(day=>day.index!==7 && day.index!==6)  
    }
      
    modal.openModal(TPL_CHOOSEFIRSTDAY,{
      settings:FwDatas.getSettingsPerFamily(),
      weekdays:weekdays
    })
  },
  mpsetfirstday(day){
    modal.closeModal();
    var 
      settings = FwDatas.getSettingsPerFamily();
    settings.mealplannerFirstDayOfWeek = day;
    ApiServer.settingssetperfamily(settings,function(result){
      FwDatas.setSettingsPerFamily(result);
      range = undefined;
      displayWeek()
    });
    
  },
  mealadd(){
    var dishNodes = $(document).find('.mp-dish');
    if(dishNodes.length){
      DomTool.nextSlot(dishNodes.last()).trigger('click')
    }else{
      $(document).find('.mp-slot').first().trigger('click')
    }
    
  },
  async mptooglecal(){
    const settings = await MealplannerSettingsCache.need()
    settings.viewCalendar = !settings.viewCalendar;
    updateMealplannerSettings(settings);
    modal.closeModal()
    displayWeek();
  },
  async mpsettingsWE(p){
    const settings = await MealplannerSettingsCache.need()
    settings.showWeekEnd = (p==="show");
    updateMealplannerSettings(settings);
    modal.closeModal()
    displayWeek();
  },
  mpprevweek(){
    amplify.publish('mpprevweek')
  },
  mpnextweek(){
    amplify.publish('mpnextweek')
  },
  mpsettingsshowWeekEnddisabled(){
    modal.toast({emoji:'⚠️',text:'mp.settingsshowWeekEnddisabled'},0)
  },
  mptoday(){
    range = undefined;
    displayWeek()
  },
  mppicklist(metaId){
    defaultList = FwDatas.get(metaId);
    amplify.publish("taskNeedRefresh");
  },
  async mpsettings(){
    var changed = await mealplannerModal.modalmealplannersettings();
    if(changed){
      displayWeek()
    }
  },
  mpmealcreate(){
    mealplannerModal.modalMeal()
  },
  mpmealedit(){
    var thisNode = this.get(0)

    mealplannerModal.modalMealEditSimple(
      thisNode.closest('[date]').getAttribute('date'),
      thisNode.closest('[dishtypeenum]').getAttribute('dishtypeenum')
    )
    return true;
  },
  mpcopyweek(){
    mealplannerModal.openCopyWeek(range.start,range.prev);
  },
  mpclear(){
    modal.confirmDelete('mp.confirmdeleteweek',function(){
      ApiServer.mpclear(
          DateUtils.forInputDate(range.start),
          DateUtils.forInputDate(range.end)
          );
      dishSyncCache.invalidate();    
      displayWeek();  
    })
    
  },
  mpaddtolistopen(){
    shopModal(range)
  },
  mpaddtolist(){
    var 
      shopList = [],
      listId = this.parents('form').find('select').val();
    this.parents('form').find('[data-dishId]').each(function(idx,obj){
      var 
        dishNode = $(obj),
        toShop = new ApiServer.types.ShoppingIngredientInputBean({
          dishMetaId:dishNode.attr('data-dishId'),
          ingredientList:[]
        });
      
      if(dishNode.find(".mp-dish-ingredient").length===0){
        toShop.ingredientList = null;
      }else{
        dishNode.find('.mp-dish-ingredient:checked').each(function(idx,checkbox){
          toShop.ingredientList.push(checkbox.value);
        })
      }
      if(dishNode.find(':checked').length){
        shopList.push(toShop);
      }
      
    });
    ApiServer.mpadditemtolist(shopList,listId);
    defaultList = FwDatas.get(listId);
    amplify.publish("taskNeedRefresh");
    modal.closeModal();
  },
  
  mpadditemtolist(){
    shopModal(null,[FwDatas.get(this.metaId())]);
  },
  mpoptionaladd(){
    var opt = $('.mpoptional');
    if(opt.length===1){
      this.hide();
    }
    opt.first().removeClass('mpoptional').show().find("[data-widget='widget/form/checkbox']").trigger('click');
  },
  mpshare(){
    ApiServer.mpsharedlink(DateUtils.forInputDate(range.start), DateUtils.forInputDate(range.end),function(bean){
      import("../modal/dialog_share.mustache").then(function(TPL){
        modal.openModal(TPL,{title: 'mp.share',message:'mp.sharetext',link:bean.link,pictureUrl:FwDatas.getFamily().coverUri});
      })
    })
  },
  mpclick(metaId){
    amplify.publish('mpclick',metaId||this.metaId())
  },
  mprecipeedit(focus){
    libLocation.goTo(libUrl.addParams(INR.URL.RECIPEBOX,{
      mode:"edit",
      id:this.metaId(),
      focus:focus?focus:undefined
    }));
  },
  mprecipeview(){
    libLocation.goTo(libUrl.addParams(INR.URL.RECIPEBOX,{
      id:this.metaId()
    }));
  },
  mpstar(){
    let 
      recipe = FwDatas.get(this.metaId());
    
    recipe.setFavorite(true)
    ApiServer.mprecipeput(recipe,item=>{
      Object.assign(FwDatas.get(item.metaId),item);
      refreshMood(this.metaIdNode().find('[data-fw-onclick=mpstar]').last(),item)
    })
  },
  mpunstar(){
    let 
      recipe = FwDatas.get(this.metaId());
  
    recipe.setFavorite(false);
    ApiServer.mprecipeput(recipe,item=>{
      Object.assign(FwDatas.get(item.metaId),item);
      refreshMood(this.metaIdNode().find('[data-fw-onclick=mpunstar]').last(),item)
    })
  },
  mpdelete(){
    var 
      dishNode = $(this).parent(),
      slotNode = dishNode.parents(".mp-slot"),
      dishType = slotNode.attr('dishTypeEnum'),
      dayKey = slotNode.parent().attr('date'),
      slotDatas = daysByKey[dayKey].dishByType[dishType];
    
    slotDatas.removeMetaId(dishNode.metaId())
    dishNode.remove();
    ApiServer.metadelete([dishNode.metaId()]);
    dishSyncCache.invalidate();
  }
  
})

function refreshMood(node,item){
  import("../mealplanner/recipeMood.mustache").then(function(TPL){
    Html.replaceWith(node,TPL,item).addClass("animated bounceIn")
  })
}

function shopModal(range,dishes){
  import("../mealplanner/modal_shopit.mustache").then(function(TPL){
    
    ApiServer.loadTaskAndList(async function(lists,freshlistsById,tasks,freshtasksById,categoryList){
      if(defaultList===undefined){
        var idx = lists.findIndex(list=>list.systemId===-10);
        defaultList = lists[idx];
      }
      var theModal;
      if(range){
        dishes = (await apiCustommplist(range)).list
      }
      
      dishes.forEach(dish=>{
        //if it is not a dish but a recipe
        if(dish instanceof ApiServer.types.DishBean){
          dish.ingredientsList = FwDatas.get(dish.recipeId).ingredientsList
        }
      })
          
      
      function updateTextButton(){
        theModal.find('button[data-fw-onclick=mpaddtolist]').text(i18n.get('mp.addNitem',theModal.find('input:checked').length))
      }
      if(range){
        let displayEndDay = new Date(range.end.getTime()-1)
        range = {start:range.start,end:displayEndDay}
      }
      theModal = modal.openModal(TPL,{range:range,lists:lists,listId:defaultList.metaId,dishes:dishes}).on('click',updateTextButton);
      theModal.find('input[type=date]').on('blur',function(event){
        var 
          startDate = theModal.find('input[name=start]').dateValue(),
          endDate = theModal.find('input[name=end]').dateValue();
        if(endDate<startDate){
          theModal.find('form').trigger('reset')
          modal.oops('mp.pickdateinvalid')
          return;
        }
        endDate.setDate(endDate.getDate()+1);
        
        apiCustommplist({start:startDate,end:endDate}).then(mplistResponse=>{
          dishes = mplistResponse.list;
          dishes.forEach(dish=>{
            dish.ingredientsList = FwDatas.get(dish.recipeId).ingredientsList
          })
          import("../mealplanner/modal_shopit_content.mustache").then(TPL_content=>{
            Html.setHtml($('#shopitlist'),TPL_content,{dishes:dishes})
            updateTextButton();
          }) 
        })
      })
      updateTextButton()
    })
  });
}

async function displayWeek(){
  if(range===undefined){
    range = getWeekRange(new Date())
  }
  
  $('#weekdisplay').html(range.name)
  var dishList = await apiCustommplist(range),
  settings = await MealplannerSettingsCache.need();
  daysByKey = dishList.daysByKey;
  
  
  if(settings.viewCalendar){
    //TODO convert that to promise
    await EventStore.loadEventsBySync(selectedCalendarIds,[],{start:range.start,end:range.end}).then(events=>{
      events.forEach(function(event){
        var 
          dayKey = DateUtils.forInputDate(event.start),
          day = daysByKey[dayKey],
          title = event.title;
        
        if(day){
          if(!event.allDay){
            title = title + ' '+DateUtils.format(event.start,'LT')
          }
          day.events.push({color:event.color||FizConfig.defaultColor,title:title,metaId:event.metaId});
        }  
      })
      
    });
  }
  ApiServer.aftergroup(function(){
    Html.setHtml($("#planner-pane"),TPL_PLANNING,{days:dishList.days,settings:settings});
  })
  
  
}
INR.onPage(INR.URL.MEALPLANNER,async function(){
  //can be accessed only by premium users
  if(FwDatas.getPermission('mealPlannerFlag')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  selectedCalendarIds = (await EventStore.getSelectedCalendarIds()).filter(calendarMetaId=>calendarMetaId.indexOf('calendarMealPlanner/')!==0)
  
  displayWeek()
  initPaneRight()
  mealplannerrightpane()

  INR.subscribe("dishChange eventDeleted eventUpdated",function(){
    displayWeek()
  })
  INR.subscribe("taskRefreshed",refreshTask);
  refreshTask()
  
  INR.subscribe("mpprevweek",function(){
    range = getWeekRange(range.prev)
    displayWeek()
  })
  INR.subscribe("mpnextweek",function(){
    range = getWeekRange(range.next)
    displayWeek()
  })
  
  
  INR.subscribe("taskListCreated",function(list){
    defaultList = list;
  });
});

async function refreshTask(){
  const 
    [[lists,categoryList,tasks,recipes],settings] = await Promise.all([MetaTaskCache.need(),MealplannerSettingsCache.need()])
    
  if(defaultList){
    defaultList = TaskListCache.get(defaultList.metaId);
  }  
  if(defaultList==null){
    defaultList = TaskListCache.get(settings.defaultAddMealToListId);
  }
  if(defaultList===null){
    var idx = lists.findIndex(list=>list.systemId===-10);
    defaultList = lists[idx]||lists[0];
  }
  var TPL = await import("../mealplanner/tasklist.mustache")
  Html.setHtml($("#task-list"),TPL,{list:defaultList,all:lists});
  
}

const DomTool = {
  prevSlot:function(item){
    let nextSlot = item.parents(".mp-slot").prev(".mp-slot");
    if(nextSlot.length===0){
      nextSlot = item.parents(".mp-slot").parent().prev().last(".mp-slot")
    }
    return nextSlot;
  },
  nextSlot:function(item){
    let nextSlot = item.parents(".mp-slot").next(".mp-slot");
    if(nextSlot.length===0){
      nextSlot = item.parents(".mp-slot").parent().next().first(".mp-slot")
    }
    return nextSlot;
  }
}
amplify.subscribe('dishCreated',function(dishes){
  var 
    dayKey = dishes[0].date,
    dishType = dishes[0].type,
    slotNode = $('tr[date='+dayKey+'] td[dishtypeenum='+dishType+']'),
    slotData = daysByKey[dayKey].dishByType[dishType];
  
  dishes.forEach(d=>slotData.push(d));
  Html.setHtml(slotNode,TPL_SLOTCONTENT,slotData);
  slotNode.trigger('click');
})  

$(document).on('click','.mp-slot.hover-controller',function(evt){
  if(evt.target.closest('[data-fw-onclick]')) return;
  function createFromInput(){
    var 
      slotNode = input.parents(".mp-slot"),
      dishType = slotNode.attr('dishTypeEnum'),
      dayKey = slotNode.parent().attr('date');
    
    ApiServer.mpcreate([input.val()],dayKey,dishType,function(createdDishes){
      amplify.publish('dishCreated',createdDishes)
      
    });
    dishSyncCache.invalidate();
    recipeSyncCache.invalidate();
    amplify.publish("recipeNeedRefresh")
  }
  
  var 
    div = $(this)
      .find('div')
      .first()
      .addClass("selected"),
    input = 
      div.append('<input type="text" name="dish" style="width:100%" list="history-data-list"/>')
      
      .find('input')
      .on('input',function(evt){
        //when we click on a suggestion 
        //on chrome evt.originalEvent.inputType  and evt.originalEvent.data are undefined
        //on firefox originalEvent.inputType==="insertReplacementText"
        if((evt.originalEvent.inputType===undefined && evt.originalEvent.data===undefined)||evt.originalEvent.inputType==="insertReplacementText"){
          createFromInput();
        }
        //for IE and safari a little prayer was done
        //console.log(JSON.stringify(evt))
      })
      .on('click',function(evt){
        evt.stopPropagation()
      })
      .on('blur',function(){
        $(this).remove();
        div.removeClass('selected');
      })
      .on('keydown',function(evt){
        if(evt.keyCode===27){ //escape
          $(this).blur();
          return;
        }
        if(evt.keyCode===13 || evt.keyCode===10 || evt.keyCode===9){ //enter or return or tabulation
          evt.preventDefault();
          if(this.value.trim().length===0){
            if(evt.keyCode===9){ //tabulation
              if(evt.shiftKey){
                DomTool.prevSlot($(this)).trigger("click")
              }else{
                DomTool.nextSlot($(this)).trigger("click")
              }
              
            }
            return;
          }
          createFromInput();
        }
      })
      .focus();
  
  
});


//drag n drop
registerDragStart(".mp-dish, .mp-recipe",async function(ev,dropPromiseBuilder){
  try{
    var 
      droppedEvent = await dropPromiseBuilder(this,document.querySelectorAll(".mp-slot, .fw-todoPanel"));
  }catch(e){
    return
  }
    
  var  
    dropped = droppedEvent.target,
    dragDishNode = this,
    isDish = this.classList.contains('mp-dish'),
    metaId = this.metaId();

  
  if(dropped.classList.contains('fw-todoPanel')){
    var 
      permission = FwDatas.getPermission("mpadditemtolist")
    if(permission!=="mpadditemtolist" ){
      if(permission){
        Html.fwtrigger(permission)
      }
      return;
    }
    ApiServer.mpadditemtolist([new ApiServer.types.ShoppingIngredientInputBean({
      dishMetaId:metaId
    })],dropped.metaId());
    amplify.publish("taskNeedRefresh");
  }else{
    var
      dishTypeTarget = dropped.getAttribute('dishTypeEnum'),
      dayKeyTarget = dropped.parentElement.getAttribute('date'),
      slotDataTarget = daysByKey[dayKeyTarget].dishByType[dishTypeTarget];
    
    if(isDish){
      var 
        prevSlotNode = dragDishNode.parents(".mp-slot"),
        dishType = prevSlotNode.getAttribute('dishTypeEnum'),
        dayKey = prevSlotNode.parentElement.getAttribute('date'),
        slotData = daysByKey[dayKey].dishByType[dishType];
        
      slotData.removeMetaId(metaId)
      Html.setHtml($(prevSlotNode),TPL_SLOTCONTENT,slotData);
    }  
    
    
    ApiServer.mpmove([metaId],dayKeyTarget,dishTypeTarget,function(newDishes){
      newDishes.forEach(newDish=>slotDataTarget.push(newDish));
      Html.setHtml($(dropped),TPL_SLOTCONTENT,slotDataTarget);
    });
    dishSyncCache.invalidate();
  }  
  
});